// extracted by mini-css-extract-plugin
export default {"main":"ProjectsListMin_main__VjCsf","table":"ProjectsListMin_table__oYcx2"};